import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const PrivilegeRoutes = defineRoute({
    record: {
        route: {
            path: "/privilege",
            component: () => loadView(import("./PrivilegeTable.vue")),
        },
    },
    create: {
        route: {
            path: "/privilege/create",
            component: () => loadView(import("./PrivilegeCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/privilege/update/:id",
            component: () => loadView(import("./PrivilegeUpdate.vue")),
        },
        build(id: string) {
            return `/privilege/update/${id}`;
        },
    },
});
